import type { FC } from 'react'
import { Box, Button, Typography } from '@mui/material'
import { userPhoneChangeRequest } from '@fireflyhealth/api'
import { useMutation } from '~/shared/hooks/promiseState'
import { useDispatch } from 'react-redux'
import { FFModal } from '~/shared/ui'
import { queueNotification } from '~/shared/notifications/actions'
import { usePatientDetail } from '~/features/member-profile'
import { logger } from '~/shared/lib/logger'

interface PhoneNumberChangeModalProps {
  handleClose: () => void
  open?: boolean
}

const PhoneNumberChangeModal: FC<PhoneNumberChangeModalProps> = props => {
  const { id } = usePatientDetail()
  const dispatch = useDispatch()
  const { run, loading } = useMutation(async () => {
    try {
      await userPhoneChangeRequest.create({ patient_id: String(id) })
      dispatch(queueNotification({ message: 'Phone number change email sent', variant: 'success' }))
      props.handleClose()
    } catch (e) {
      if (e instanceof Error) {
        logger.error('[Patient] send phone number change email', e)
      }
      dispatch(queueNotification({ message: 'Failed to send', variant: 'error' }))
    }
  })

  return (
    <FFModal open>
      <Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', py: 6, px: 4 }}>
          <Box>
            <Typography variant="h6">Change Member’s Phone Number</Typography>
            <Box sx={{ mt: 3, mb: 2 }}>
              <Typography>
                For security reasons, members can’t directly change their number. We can’t either.
                Instead, we email them a link to do this using multi-factor authentication (MFA) .
              </Typography>
            </Box>
            <Typography>
              They’ll receive the email within 5 minutes. When they click the link, they’ll verify
              their identity and enter their new number.
            </Typography>
          </Box>
          <Box sx={{ mt: 4 }}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Box sx={{ mr: 1 }}>
                <Button disabled={loading} onClick={props.handleClose} color="secondary">
                  Cancel
                </Button>
              </Box>
              <Button onClick={run} disabled={loading} color="primary" variant="contained">
                Send
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </FFModal>
  )
}

export default PhoneNumberChangeModal
